
import { Component, Vue } from "vue-property-decorator";
import { dateFormatter } from "../../components/formatters";
import PdfGenerator from "@/export/pdf";
import { getUserActivityFieldsForExport } from "@/export/util";
import { generateSpreadsheetSingleTableAndDownload } from "@/export/excel";

@Component({
  methods: { dateFormatter },
  components: {}
})
export default class UserActivity extends Vue {
  apiLocation = Vue.prototype.$apiLocation;
  client = Vue.prototype.$surveyClient;
  activity: any[] = [];
  hasSearched = false;
  loading = false;
  error = "";

  get fields() {
    return [
      { key: "user", sortable: true },
      { key: "action", sortable: true },
      { key: "objectType", sortable: true },
      { key: "happenedTimestamp", sortable: true, label: "Date" }
    ];
  }

  get formattedStart() {
    if(this.$data.start === null){
      return "Beginning";
    }
    return dateFormatter("MM/DD/YYYY")(this.$data.start);
  }

  get formattedEnd() {
    return dateFormatter("MM/DD/YYYY")(this.$data.end);
  }

  get hasResults() {
    return this.hasSearched && this.activity.length > 0;
  }

  data() {
    const d = { filter: "", start: this.defaultStart(), end: this.defaultEnd() };
    return d;
  }

  defaultStart() {
    return new Date(2023, 0, 1)
  }

  defaultEnd() {
    return new Date();
  }
  get username() {
    return this.$route.params.username;
  }

  async searchActivity() {
    if (this.loading) return;
    const start = this.selectedStartMillis();
    const end = this.selectedEndMillis();
    if (start > end) {
      this.hasSearched = true;
      this.activity = [];
      this.error = "Start date must be before or equal to end date.";
      return;
    }
    this.loading = true;
    this.error = "";
    this.hasSearched = true;
    this.activity = [];
    try {
      const userActivity = await this.client.getAllUserActivity(
        start,
        end
      );
      this.activity = userActivity;
    } catch (error) {
      this.error = "Unable to load user activity records. Please try a smaller date range or contact support if the problem continues.";
    } finally {
      this.loading = false;
    }
  }

  exportTableData() {
    if (!this.hasResults) return;
    const table: any = this.$refs.theTable;
    new PdfGenerator()
      .getUserActivityTable(table.computedItems)
      .then((pdfDoc: any) => {
        pdfDoc.download(`user-activity.pdf`);
      });
  }

  exportTableDataExcel() {
    if (!this.hasResults) return;
    const table: any = this.$refs.theTable;
    const data: string[][] = [['User', 'Action', 'Object Type', 'Date']].concat(
      getUserActivityFieldsForExport(table.computedItems)
    );
    generateSpreadsheetSingleTableAndDownload(data, "priplan-activity.xlsx");
  }

  hasRequestDetails(requestData: string | null | undefined) {
    return requestData !== null && requestData !== undefined && requestData.length > 2;
  }

  requestDetails(requestData: string | null | undefined) {
    if (!this.hasRequestDetails(requestData)) {
      return {};
    }
    try {
      return JSON.parse(requestData as string);
    } catch (error) {
      return { requestData };
    }
  }

  selectedStartMillis() {
    const start = new Date(this.$data.start);
    start.setHours(0, 0, 0, 0);
    return start.getTime();
  }

  selectedEndMillis() {
    const end = new Date(this.$data.end);
    end.setHours(23, 59, 59, 999);
    return end.getTime();
  }
}
